import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router";
import { Menu, X } from "lucide-react";
import { HIREOS_INQUIRY_URL } from "../../hireos-links";

const HIDDEN_PATHS = [
  "/collect-balance",
  "/pay-balance",
  "/pay-contractor",
  "/approve",
];

export function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { pathname } = useLocation();

  // The open menu is a fixed full-screen overlay; lock the page scroll
  // behind it so the content underneath doesn't move.
  useEffect(() => {
    document.body.style.overflow = mobileMenuOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [mobileMenuOpen]);

  // Hide header on HireOS-redirect token pages
  if (HIDDEN_PATHS.some((p) => pathname.startsWith(p))) {
    return null;
  }

  return (
    <header className="bg-white sticky top-0 z-50 border-b border-gray-100">
      <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/">
            <img
              src="/images/logowhiteheader.webp"
              alt="Accent Productions"
              width={180}
              height={50}
              className="h-12 w-auto"
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/services"
              className="text-gray-900 font-medium cursor-pointer py-2.5"
            >
              Services
            </Link>
            <Link
              to="/about"
              className="text-gray-900 font-medium cursor-pointer py-2.5"
            >
              About
            </Link>
            <Link
              to="/contact"
              className="text-gray-900 font-medium cursor-pointer py-2.5"
            >
              Contact
            </Link>
            <a
              href={HIREOS_INQUIRY_URL}
              className="bg-orange-600 text-white px-6 py-2.5 rounded-md font-bold border border-orange-600"
            >
              Get a Quote
            </a>
          </div>

          {/* Mobile menu button */}
          <button
            className="md:hidden p-2 rounded-md cursor-pointer"
            aria-label={mobileMenuOpen ? "Close menu" : "Open menu"}
            aria-expanded={mobileMenuOpen}
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? (
              <X className="w-6 h-6" />
            ) : (
              <Menu className="w-6 h-6" />
            )}
          </button>
        </div>

        {/* Mobile Navigation — fixed full-screen overlay on top of the page
            (z-40, under the z-50 header so the logo and X stay visible).
            Snaps open/closed, no slide (DESIGN.md Motion: none). */}
        <div
          inert={!mobileMenuOpen}
          className={`md:hidden fixed inset-0 z-40 bg-white ${
            mobileMenuOpen ? "block" : "hidden"
          }`}
        >
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-28 pb-10">
            <div className="flex flex-col gap-7">
              <Link
                to="/"
                className="text-3xl font-bold tracking-tight text-gray-900 cursor-pointer"
                onClick={() => setMobileMenuOpen(false)}
              >
                Home
              </Link>
              <Link
                to="/services"
                className="text-3xl font-bold tracking-tight text-gray-900 cursor-pointer"
                onClick={() => setMobileMenuOpen(false)}
              >
                Services
              </Link>
              <Link
                to="/about"
                className="text-3xl font-bold tracking-tight text-gray-900 cursor-pointer"
                onClick={() => setMobileMenuOpen(false)}
              >
                About
              </Link>
              <Link
                to="/contact"
                className="text-3xl font-bold tracking-tight text-gray-900 cursor-pointer"
                onClick={() => setMobileMenuOpen(false)}
              >
                Contact
              </Link>
              <a
                href={HIREOS_INQUIRY_URL}
                className="text-3xl font-bold tracking-tight text-orange-600 cursor-pointer"
                onClick={() => setMobileMenuOpen(false)}
              >
                Get a Quote
              </a>
            </div>
          </div>
        </div>
      </nav>
    </header>
  );
}
